import { useSelector } from "react-redux";
import { AppDispatch } from "store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { FormatDateShort } from "utils/dateUtils";
import classesStock from "../../../popover.module.scss";
import classes from "../../../../../../components/Popover/popover.module.scss";
import { styles as popoverSelectStyles } from "../../../../../../components/Popover/popoverSelectStyle";

import {
  selectState,
  setEditPopover,
  updateOutputItems,
} from "../outputSlice";
import { toast } from "react-toastify";
import InputSelect from "../../Input/components/InputSelect";
import { IUpdateOutputItemComand } from "Dashboard/scenes/Stock/domain/IUpdateOutputItemComand";
import NumberInput from "Dashboard/components/NumberInput";
import { IUpdateOutputComand } from "Dashboard/scenes/Stock/domain/IUpdateOutputCommand";
import { useEffect, useState } from "react";
import { IStockInput } from "Dashboard/scenes/Stock/domain/IStockInput";
import { stockService } from "Dashboard/scenes/Stock/services/stock.service";

interface IProps {
  dispatch: AppDispatch;
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const EditOutput = ({
  dispatch,
  setClickOutsideActive,
}: IProps) => {

  const { outputForEdit } = useSelector(selectState);
  const [editOutputItemCommands, setEditOutputItemCommands] = useState<IUpdateOutputItemComand[] | null>(null);
  const [inputs, setInputs] = useState<IStockInput[]>([]);


  useEffect(() => {
    async function loadInputs() {
      const abortCtrl = new AbortController();
      const inputsEnriched = await stockService.getStockInputs(
        { stock: "Lager" }, { fetchMode: "replace" }, abortCtrl.signal
      );
      setInputs(inputsEnriched.inputs);
    }
    try {
      loadInputs();
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    if (outputForEdit) {
      const initialCommands = outputForEdit.items.map(item => ({
        outputItemId: item.outputItemId,
        newInputId: item.inputId,
        newQuantityAmount: item.quantityAmount
      }));
      setEditOutputItemCommands(initialCommands);
    }
  }, [outputForEdit]);


  if (editOutputItemCommands === null || outputForEdit === null) {
    return (<>GREŠKA</>);
  }

  const onSubmitAll = async () => {
    try {
      await dispatch(
        updateOutputItems(getSubmitData())
      ).unwrap();
      handleSuccessfulEdit();
    } catch (status) {
      if (status === 403) {
        toast.error("Nije dozvoljena izmena u lageru (da li ste zaposleni u firmi?)");
      } else if (status === 406) {
        toast.error("Izmena nije zabeležena jer uneti podaci ne odgovaraju stanju na lageru (proverite da li ima dovoljno zaliha na lageru, da li je stavka iz istog magacina...)");
      } else {
        toast.error("Izmena nije zabeležena zbog neočekivane greške");
      }
    }
  };

  const getSubmitData = (): IUpdateOutputComand => {
    let data: IUpdateOutputComand = {
      items: editOutputItemCommands,
      outputId: outputForEdit.outputId,
    };

    return data;
  }

  const handleSuccessfulEdit = () => {
    dispatch(setEditPopover({
      isOpen: false
    }));
    toast.success("Izmena je zabeležena");
  }

  const onChangeQuantity = (outputItemId: number, newQuantity: number) => {
    var newEditOutputItemCommands = editOutputItemCommands.map(item => {
      if (item.outputItemId === outputItemId) {
        return {
          ...item,
          newQuantityAmount: newQuantity || 0
        };
      } else {
        return item;
      }
    });
    setEditOutputItemCommands([...newEditOutputItemCommands]);
  };

  const onInputChange = (outputItemId: number, newInputId: number | null) => {
    var newEditOutputItemCommands = editOutputItemCommands.map(item => {
      if (item.outputItemId === outputItemId) {
        return {
          ...item,
          newInputId: newInputId ? newInputId : item.newInputId
        };
      } else {
        return item;
      }
    });
    setEditOutputItemCommands([...newEditOutputItemCommands]);
  }

  return (
    <section className={`${classesStock.editOutputPopover} ${classes.basicPopover}`}>
      <div className={`${classes.row} ${classes.rowDir}`}>
        <div className={`${classes.col} ${classes.colDir} ${classesStock.outputList}`}>
          <div className={`g-grid g-header ${classesStock.gHeader}`}>
            <div className={`row ${classesStock.row}`}>
              <div className="col center lowercase separator-line">br otpr.</div>
              <div className="col center lowercase separator-line">naziv</div>
              <div className="col center lowercase separator-line">količina</div>
              <div className="col center lowercase separator-line">datum</div>
            </div>
          </div>
          <div className={`g-grid g-content ${classesStock.gContent}`}>
            {editOutputItemCommands.map((item, index) => {
              return (
                <div className={`row ${classesStock.row}`} key={index}>
                  <div className="col center">
                    <div className="bg-item bg-transparent center">
                      {index === 0 && outputForEdit.billOfLandingId}
                    </div>
                  </div>
                  <div className="col">
                    <InputSelect
                      customStyles={popoverSelectStyles.rowInMainTable}
                      selectedInputId={item.newInputId}
                      inputs={inputs}
                      onChange={(value: number | null) => onInputChange(item.outputItemId, value)}
                    />
                  </div>
                  <div className="col center">
                    <NumberInput
                      formatAs="quantity"
                      value={`${item.newQuantityAmount}`}
                      onChange={(value: string, unmaskedValue: string, parsedValue: number) => onChangeQuantity(item.outputItemId, parsedValue)}
                      className={`bg-item center`}
                    />
                  </div>
                  <div className="col center">
                    <div className="bg-item bg-transparent center">
                      {index === 0 && FormatDateShort(outputForEdit.date)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className={classesStock.actions}>
        <div className={classesStock.bot}>
          <div onClick={() => onSubmitAll()} className={classesStock.iconDiv}>
            <FontAwesomeIcon icon={faLongArrowAltDown} className={classesStock.icon} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditOutput;
